export enum HublerEmploymentStatus {
  EMPLOYEE = 0,
  VACATAIRE = 1,
  VACATAIRE_EXT_IN_NETWORK = 2,
  VACATAIRE_EXT_MARKETPLACE = 3,
  TEMPORARY_PERSON = 4,
  HUBLO_POOL = 5,
  INTERNAL_POOL = 6,
}

// Filter possible HublerEmploymentStatus enum values for the onboarding status step
export type OnboardingHublerEmploymentStatus = Exclude<
  HublerEmploymentStatus,
  | HublerEmploymentStatus.HUBLO_POOL
  | HublerEmploymentStatus.TEMPORARY_PERSON
  | HublerEmploymentStatus.VACATAIRE_EXT_MARKETPLACE
>
